import { render, staticRenderFns } from "./DesplegarComentariosVendedor.vue?vue&type=template&id=ccb296b8"
import script from "./DesplegarComentariosVendedor.vue?vue&type=script&lang=js"
export * from "./DesplegarComentariosVendedor.vue?vue&type=script&lang=js"
import style0 from "./DesplegarComentariosVendedor.vue?vue&type=style&index=0&id=ccb296b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports